import { useLocation, useNavigate } from 'react-router-dom';
import { Icon28HomeOutline, Icon28WalletOutline, Icon28UsersOutline, Icon28CheckCircleOutline, Icon28SettingsOutline } from '@vkontakte/icons';

const TABS = [
  { path: '/', label: 'Главная', icon: Icon28HomeOutline },
  { path: '/budget', label: 'Бюджет', icon: Icon28WalletOutline },
  { path: '/guests', label: 'Гости', icon: Icon28UsersOutline },
  { path: '/tasks', label: 'Задачи', icon: Icon28CheckCircleOutline },
  { path: '/settings', label: 'Настройки', icon: Icon28SettingsOutline },
] as const;

export default function TabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="colibri-tabbar" aria-label="Навигация">
      {TABS.map(({ path, label, icon: Icon }) => {
        const active = path === '/' ? pathname === '/' : pathname === path || pathname.startsWith(path + '/');
        return (
          <button
            key={path}
            type="button"
            className={`colibri-tabbar__item${active ? ' colibri-tabbar__item--active' : ''}`}
            onClick={() => navigate(path)}
            aria-current={active ? 'page' : undefined}
          >
            <Icon width={22} height={22} />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
